export const Instagram = () => (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.351 28.5727H14.5108C10.9141 28.5727 6.97629 26.0491 5.43817 24.3288C-2.65144 15.284 3.52563 1.39511 15.5617 1.39511C17.5437 1.39511 19.4027 1.85289 20.9813 2.56404C22.7478 3.36012 23.6398 4.08278 24.977 5.25747C28.8208 8.63181 30.1609 15.3575 28.0735 20.1584C27.6933 21.0308 27.4099 21.5346 26.9415 22.3063C24.9365 25.6173 20.4855 28.5741 16.351 28.5741V28.5727ZM13.5263 0.164279C10.7681 0.603347 7.7468 1.70318 5.76343 3.56598C3.46058 5.7282 2.38794 6.94896 1.18953 10.2744C-0.83865 15.9059 1.31386 23.1254 5.86173 26.5242C9.01171 28.8779 13.0204 30.5492 17.2791 29.8323C19.4764 29.4623 21.3037 28.9599 22.8881 27.9566C26.1045 25.921 28.2903 23.6969 29.6463 19.7654C31.3391 14.8579 30.1927 9.14574 26.9401 5.39854C23.8798 1.87304 18.8823 -0.686505 13.5263 0.164279Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5665 10.1521C13.6058 9.98653 16.1732 10.1089 17.4078 10.1118C21.123 10.1219 20.3004 13.5279 20.2874 17.1297C20.2816 18.6973 19.6311 19.8087 18.1855 20.0246C17.0276 20.1974 14.4992 20.0534 13.1924 20.0563C9.45117 20.0664 10.2694 16.5898 10.2997 12.9276C10.3142 11.2174 10.9835 10.404 12.565 10.1506L12.5665 10.1521ZM9.08254 13.5898C9.08254 16.551 8.45515 21.2713 12.9322 21.2713H17.6651C19.6817 21.2713 21.4396 19.7266 21.4396 17.7803V12.4122C21.4396 10.6027 19.767 8.89966 17.9282 8.89966H12.6734C11.4851 8.89966 10.4747 9.62664 9.96147 10.2385C9.18373 11.1655 9.08254 12.1257 9.08254 13.5898Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7233 12.9951C17.4165 12.1933 18.6857 16.4012 15.8986 17.1944C14.557 17.5773 13.3774 16.6574 13.1924 15.6742C12.9206 14.2245 13.642 13.3176 14.7247 12.9951H14.7233ZM14.9416 11.7384C10.2275 12.6597 11.3998 18.9362 15.8191 18.4166C17.5364 18.2136 18.8751 16.6056 18.6221 14.5974C18.4125 12.9361 16.7905 11.3771 14.943 11.7384H14.9416Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0601 12.0982C19.1685 11.4519 18.969 11.2863 18.3229 11.3799C17.7952 12.0752 18.3272 12.484 19.0601 12.0982Z"
      fill="currentColor"
    />
  </svg>
)
